import { EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type SourcingEvents =
  | 'CREATE'
  | 'CREATE_QUICK_ACTION'
  | 'TABLE_JOB_POSTING_TITLE_CELL_CLICK'
  | 'TABLE_JOB_POSTING_ASSOCIATED_WORK_REQUEST_CELL_CLICK'
  | 'TABLE_JOB_POSTING_CANDIDATES_CELL_CLICK'
  | 'TABLE_JOB_POSTING_INVITED_SUPPLIERS_CELL_CLICK'
  | 'TABLE_JOB_POSTING_OVERFLOW_ACTIONS_CELL_CLICK'
  | 'TABLE_JOB_APPLICATION_OVERFLOW_ACTIONS_CELL_CLICK'
  | 'TABLE_WORK_REQUEST_OVERFLOW_ACTIONS_CELL_CLICK'
  | 'EXPORT_WORK_REQUEST_RESULT'
  | 'EXPORT_JOB_APPLICATION_RESULT';

export const sourcing: Record<SourcingEvents, MixpanelEvent> = {
  CREATE: {
    eventDescription: 'Create Work Request via Hub Start Button',
    eventKey: 'work-request-create-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  CREATE_QUICK_ACTION: {
    eventDescription: 'Create Work Request via Quick Action',
    eventKey: 'work-request-create-quick-action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  TABLE_JOB_POSTING_TITLE_CELL_CLICK: {
    eventDescription: 'Click View Individual Job Posting from Job Postings Hub',
    eventKey: 'click-view-job-posting-title-from-job-postings-hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  TABLE_JOB_POSTING_ASSOCIATED_WORK_REQUEST_CELL_CLICK: {
    eventDescription: 'Click Associated Work Request link in Job Postings Hub',
    eventKey: 'click-view-associated-work-request-from-job-postings-hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  TABLE_JOB_POSTING_CANDIDATES_CELL_CLICK: {
    eventDescription: 'Click View Candidates from Job Postings Hub',
    eventKey: 'click-view-candidates-from-job-postings-hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  TABLE_JOB_POSTING_INVITED_SUPPLIERS_CELL_CLICK: {
    eventDescription: 'Click View Invites Suppliers from Job Postings Hub',
    eventKey: 'click-view-invites-suppliers-from-job-postings-hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  TABLE_JOB_POSTING_OVERFLOW_ACTIONS_CELL_CLICK: {
    eventDescription: 'Click View overflow actions from Job Postings Hub',
    eventKey: 'click-view-overflow-actions-from-job-postings-hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  TABLE_JOB_APPLICATION_OVERFLOW_ACTIONS_CELL_CLICK: {
    eventDescription: 'Click View overflow actions from Job Applications Hub',
    eventKey: 'click-view-overflow-actions-from-job-applications-hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  TABLE_WORK_REQUEST_OVERFLOW_ACTIONS_CELL_CLICK: {
    eventDescription: 'Click View overflow actions from Work Requests Hub',
    eventKey: 'click-view-overflow-actions-from-work-requests-hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  EXPORT_WORK_REQUEST_RESULT: {
    eventDescription: 'Export Work Requests report',
    eventKey: 'export-work-request-report',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  EXPORT_JOB_APPLICATION_RESULT: {
    eventDescription: 'Click export job application quick report',
    eventKey: 'click-export-job-application-quick-report',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  }
} as const;
